import FeaturedAthlete from './FeaturedAthlete';

export default FeaturedAthlete;
